import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const formatDate = (str) => {
    const date = new Date(str);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}/${month}/${day}`;
};

const Mypage = ({ onClose, onFound }) => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [results, setResults] = useState([]);
    const [searched, setSearched] = useState(false);

    const onSubmit = async (data) => {
        data.employeeId = parseInt(data.employeeId, 10);
        const params = new URLSearchParams(data);
        try {
            const res = await fetch(`${API_BASE_URL}/my-submissions.php?${params}`);
            if (!res.ok) throw new Error('サーバーエラー');
            const json = await res.json();
            setResults(json);
            if (json.length > 0) {
                // 🔸 データをHealthCheckForm側へ渡す
                onFound?.(json[0]);

                // 🔸 モーダルを閉じる
                onClose?.();
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setResults([]);
        } finally {
            setSearched(true);
        }
    };

    const handleClear = () => {
        reset();
        setResults([]);
        setSearched(false);
        onClose?.(); // モーダルを閉じる（★）
    };

    return (
        <div>
            <h2>自分のアンケート確認</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <label>名前</label>
                    <input
                        placeholder='例）山田太郎'
                        {...register('name', { required: '名前は必須です' })} />
                    {errors.name && <p>{errors.name.message}</p>}
                </div>

                <div>
                    <label>社員番号</label>
                    <input
                        type="text"
                        maxLength="2"
                        placeholder='例）02 ⇒ 2'
                        {...register('employeeId', {
                            required: '社員番号は必須です',
                            validate: (value) => /^\d{1,2}$/.test(value) || '1〜2桁の半角数字で入力してください',
                        })}
                        onInput={(e) => {
                            const normalized = e.target.value.replace(/[０-９]/g, (s) =>
                                String.fromCharCode(s.charCodeAt(0) - 65248)
                            );
                            e.target.value = normalized.slice(0, 2);
                        }}
                    />
                    {errors.employeeId && <p>{errors.employeeId.message}</p>}
                </div>

                <div style={{ marginTop: '10px' }}>
                    <button type="submit" style={{ backgroundColor: '#1890ff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px' }}>
                        検索
                    </button>
                    {/* <button type="button" onClick={handleClear} style={{ marginLeft: '10px', backgroundColor: '#f5222d', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px' }}>
                        クリア
                    </button> */}
                </div>
            </form>

            {searched && (
                results.length > 0 ? (
                    <div style={{ marginTop: '20px' }}>
                        <h3>検索結果</h3>
                        <ul>
                            {results.map((r) => (
                                <li key={r.id}>
                                    <strong>受診場所:</strong> {r.location}<br />
                                    <strong>第一希望日時:</strong> {formatDate(r.firstChoice)}<br />
                                    <strong>第二希望日時:</strong> {formatDate(r.secondChoice)}<br />
                                    <strong>胃部検査:</strong> {r.gastricTest}<br />
                                    <strong>問診票送付先:</strong> {r.mailOption || '未選択'}<br />
                                    <strong>郵便番号:</strong> {r.postalCode || '未登録'}<br />
                                    <strong>住所:</strong> {r.address || '未登録'}<br />
                                    <strong>任意検査:</strong> {r.additionalTests || 'なし'}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p style={{ marginTop: '20px' }}>該当するデータが見つかりませんでした。</p>
                )
            )}
        </div>
    );
};

export default Mypage;
